<template>
    <div>
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top">
          <el-form-item
          label="单位名称"
          prop="name"
        >
          <el-input v-model="formData.name" placeholder="单位名称" />
        </el-form-item>
        <el-form-item
          label="营业执照代码"
          prop="businessLicenseCode"
        >
          <el-input v-model="formData.businessLicenseCode" placeholder="营业执照代码" />
        </el-form-item>
        <el-form-item
          label="地址"
          prop="address"
        >
          <el-input v-model="formData.address" placeholder="地址" />
        </el-form-item>
        <el-form-item
          label="电话"
          prop="phone"
        >
          <el-input v-model="formData.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item
          label="单位性质"
          prop="nature"
        >
          <el-select v-model="formData.nature" placeholder="单位性质" style="width: 100%;">
            <el-option label="企业单位" value="企业单位" />
            <el-option label="事业单位" value="事业单位" />
            <el-option label="社会团体" value="社会团体" />
          </el-select>
        </el-form-item>
        <el-form-item
          label="经营范围"
          prop="businessScope"
        >
          <el-input v-model="formData.businessScope" placeholder="经营范围" />
        </el-form-item>
        <el-form-item
          label="法人姓名"
          prop="legalPersonName"
        >
          <el-input v-model="formData.legalPersonName" placeholder="法人姓名" />
        </el-form-item>
        <el-form-item
          label="法人身份证号"
          prop="idNumber"
        >
          <el-input
            v-model="formData.idNumber"
            placeholder="法人身份证号"
          />
        </el-form-item>
        <el-form-item
          label="法人电话"
          prop="legalPhone"
        >
          <el-input v-model="formData.legalPhone" placeholder="法人电话" />
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
        >
          <el-input
            v-model="formData.email"
            placeholder="邮箱"
          />
        </el-form-item>
        <el-form-item
          label="专业人员情况(含姓名、年龄、相关专业工作年限)"
          prop="personnel"
        >
          <el-input
            v-model="formData.personnel"
            placeholder="专业人员情况(含姓名、年龄、相关专业工作年限)"
          />
        </el-form-item>
        <el-form-item
          label="开展心理健康服务和心理教育工作的相关经验"
          prop="experience"
        >
          <el-input
            v-model="formData.experience"
            placeholder="开展心理健康服务和心理教育工作的相关经验"
          />
        </el-form-item>
        <el-form-item
          label="密码"
          prop="password"
        >
          <el-input
            v-model="formData.password"
            type="password"
            placeholder="请输入密码"
          />
        </el-form-item>
            <el-form-item>
              <el-button style="width: 100%;" type="primary" @click="submitForm('formData')" v-loading="login_loading">立即注册(需支付会费{{payMoney}}元)</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
          title="微信扫描二维码支付会费"
          :visible.sync="dialogVisible"
          v-if="dialogVisible"
          width="20%"
          :before-close="handleClose"
          >
          <div ref="qrCodeUrl" style="display: none;"></div>
          <div ref="qrCodeUrl2"></div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="zhuceFun()">支付完成，提交注册</el-button>
          </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { memberUnitRegister,createOrderUnit,commodity } from "@/api/g_login";
  import QRCode from 'qrcodejs2'
  export default {
    data(){
      return{
        headers:{
          "token":localStorage.getItem("foregroundToken")
        },
        formData: {
          name:'',
          businessLicenseCode:'',
          address:'',
          phone:'',
          nature:'',
          businessScope:'',
          legalPersonName:'',
          idNumber:'',
          legalPhone:'',
          email:'',
          personnel:'',
          experience:'',
          password: "",
        },
        rules: {
          name: [{ required: true, message: "单位名称", trigger: "blur" }],
          businessLicenseCode: [{ required: true, message: "营业执照代码", trigger: "blur" }],
          address: [{ required: true, message: "地址", trigger: "blur" }],
          phone: [
            { required: true, message: "电话", trigger: "blur" },
            { pattern: /^1[3456789]\d{9}$/, message: '电话号码格式不正确', trigger: 'blur' }
          ],
          nature: [{ required: true, message: "单位性质", trigger: "blur" }],
          businessScope: [{ required: true, message: "经营范围", trigger: "blur" }],
          legalPersonName: [{ required: true, message: "法人姓名", trigger: "blur" }],
          idNumber: [
            { required: true, message: "法人身份证号", trigger: "blur" },
            { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号格式不正确', trigger: 'blur' }
          ],
          legalPhone: [
            { required: true, message: "法人电话", trigger: "blur" },
            { pattern: /^1[3456789]\d{9}$/, message: '电话号码格式不正确', trigger: 'blur' }
          ],
          email: [{ required: true, message: "邮箱", trigger: "blur" }],
          personnel: [{ required: true, message: "专业人员情况(含姓名、年龄、相关专业工作年限)", trigger: "blur" }],
          experience: [{ required: true, message: "开展心理健康服务和心理教育工作的相关经验", trigger: "blur" }],
          password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        },
        login_loading:false,
        dialogVisible: false,
        orderNo:'',
        payMoney:'',
      }
    },
    created(){
        commodity().then((res)=>{
          this.payMoney = res.data[1].monney
        })
    },
    methods:{
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
        if (valid) {
            this.login_loading = true
            createOrderUnit(this.formData).then((res)=>{
                  this.login_loading = false
                  this.dialogVisible = true
                  this.orderNo = res.data.orderNo
                  setTimeout(() => {
                      new QRCode(this.$refs.qrCodeUrl, {
                          text: res.data.url, // 需要转换为二维码的内容
                          width: 100,
                          height: 100,
                          colorDark: '#000000',
                          colorLight: '#ffffff',
                          correctLevel: QRCode.CorrectLevel.H
                      })
                      let image = new Image();
                      image.src = this.$refs.qrCodeUrl.firstChild.toDataURL("image/png");
                      this.$refs.qrCodeUrl2.appendChild(image);
                  }, 200);
            }).finally(()=>{
              this.login_loading = false
            })
          } else {
            return false;
          }
        });
      },
      zhuceFun(){
        memberUnitRegister({orderNo:this.orderNo}).then((res)=>{
            this.$confirm('注册申请已提交，请耐心等待审核', '提示', {
              confirmButtonText: '确定',
              showCancelButton:false,
              type: 'success'
            }).then(() => {
              window.location.replace(this.$baseUrl+'/#/indexPage')
            })
        }).finally(()=>{
          this.login_loading = false
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleAvatarSuccess(res) {
        this.formData.picture = res.data.filePath
      },
      handleClose() {
        this.login_loading = false
        this.orderNo = ''
        this.dialogVisible = false
      }
    }
  }
  </script>
  <style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>